import { Box, Heading, Text, Tooltip, Icon } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { TiArrowBack } from 'react-icons/ti';

function OopsPage() {
  const navigate = useNavigate();

  return (
    <Box
      position="relative"
      textAlign="center"
      py={10}
      px={6}
      w="100%"
      h="70vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box>
        <Heading
          display="inline-block"
          as="h2"
          size="4xl"
          bgGradient="linear(to-r, brand.400, brand.800)"
          backgroundClip="text"
        >
          Oops!
        </Heading>

        <Text fontSize="24px" mt={4} mb={2} fontWeight="medium">
          Something went wrong.
        </Text>
      </Box>
    </Box>
  );
}

export default OopsPage;
